import React, { useState } from "react";
import "../Footer/Footer.css";
import link1 from "../../../img/link3.png";
import link2 from "../../../img/link5.png";
import link3 from "../../../img/link1.png";
import right from "../../../img/right.png";
import { Link } from "react-router-dom";
import LinksPage from "../LinkPage/LinksPage";
import { useDispatch } from "react-redux";
import { subscribeEmail } from "../../../Helper/Redux/API";
import { toast } from "react-toastify";

function Footer() {
  const year = new Date().getFullYear()

  const [email, setEmail] = useState("")
  const dispatch = useDispatch()

  const subEmailId = () => {
  
    const requestOption = {
      email:email
    };
  
    try {
      dispatch(subscribeEmail(requestOption)).then((res) => {
        console.log(res.payload.data);
        if (res.payload.status === true) {
          toast.success(res.payload.message)
        } else {
          toast.error(res.payload.message)

        }
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <>
      <LinksPage />
      <footer className="footer_section">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="Footer_menu">
                <h5>THE HEARING CENTRE</h5>
                <p>
                  Improved Quality Life With Our Products For You & Love OnesThe
                  Hearing Centre Pte Ltd was established in 2004 with a vision
                  to be the leader in cost-effective hearing aids and quality
                  hearing care services.
                </p>
                <h6>enquiry@thehearingcentre.sg</h6>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="Footer_menu">
                <h5>SERVICES & PRODUCTS</h5>
                <p>FIND SERVICES</p>
                <select class="form-select" aria-label="Select Service">
                  <option selected>Select Service</option>
                  <option value="1">Hearing Tests </option>
                  <option value="2">Hearing Aids </option>
                  <option value="3">Hearing Implants </option>
                  <option value="4">Ear Measurements </option>
                  <option value="5">Repairs and Adjustments </option>
                </select>

                <p>FIND PRODUCTS</p>
                <select class="form-select" aria-label="Select Product">
                  <option selected>Select Product</option>
                  <option value="1">Phonak</option>
                  <option value="2">ReSound </option>
                  <option value="3">Signia</option>
                  <option value="4">Starkey</option>
                  <option value="5">Westone</option>
                </select>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              {" "}
              <div className="Footer_menu">
                <h5>OUR BRANCHES</h5>
                <p>
                  <i className="fa fa-map-marker" aria-hidden="true"></i>
                  <a
                    target="_blank"
                    href="https://www.google.com/maps/place/The+Hearing+Centre+Pte+Ltd/@1.3045755,103.7990155,13z/data=!4m9!1m2!2m1!1sThe+Hearing+Centre+Pte+Ltd+!3m5!1s0x31da19a32f1e64c9:0x45b46ff21a6aff04!8m2!3d1.3047305!4d103.8341943!15sChpUaGUgSGVhcmluZyBDZW50cmUgUHRlIEx0ZCIDiAEBWjgKGnRoZSBoZWFyaW5nIGNlbnRyZSBwdGUgbHRkIhp0aGUgaGVhcmluZyBjZW50cmUgcHRlIGx0ZJIBEWhlYXJpbmdfYWlkX3N0b3JlmgEkQ2hkRFNVaE5NRzluUzBWSlEwRm5TVVI1Y2t0WWVqTm5SUkFC'"
                  >
                    Lucky Plaza - Main Branch
                  </a>{" "}
                </p>
                <p>
                  {" "}
                  <i className="fa fa-map-marker" aria-hidden="true"></i>
                  <a
                    target="_blank"
                    href="https://www.google.com/maps/place/The+Hearing+Centre+Pte+Ltd/@1.3342283,103.8643605,13z/data=!4m9!1m2!2m1!1sThe+Hearing+Centre+Pte+Ltd+!3m5!1s0x31da3c546948b935:0xb6fa2a212df2411a!8m2!3d1.3672004!4d103.9646185!15sChpUaGUgSGVhcmluZyBDZW50cmUgUHRlIEx0ZCIDiAEBkgEUbWVkaWNhbF9zdXBwbHlfc3RvcmU"
                  >
                    Pasir Ris Branch
                  </a>
                </p>
                <p>
                  {" "}
                  <i className="fa fa-map-marker" aria-hidden="true"></i>
                  <a
                    target="_blank"
                    href="https://www.google.com/maps/place/The+Hearing+Centre+Pte+Ltd/@1.3011904,103.8222503,13z/data=!4m9!1m2!2m1!1sThe+Hearing+Centre+Pte+Ltd+!3m5!1s0x31da193c6ead0e11:0x5c04c38daeb9523d!8m2!3d1.3011352!4d103.8573264!15sChpUaGUgSGVhcmluZyBDZW50cmUgUHRlIEx0ZCIDiAEBkgERaGVhcmluZ19haWRfc3RvcmU"
                  >
                    North Bridge Road (Raffle’s ENT Centre)
                  </a>
                </p>
                <p>
                  {" "}
                  <i className="fa fa-map-marker" aria-hidden="true"></i>{" "}
                  <a
                    target="_blank"
                    href="https://www.google.com/maps/place/The+Hearing+Centre,+Ang+Mo+Kio/@1.3385715,103.8057895,13z/data=!4m9!1m2!2m1!1sThe+Hearing+Centre+Pte+Ltd+AMK+Branch!3m5!1s0x31da17626efa3b41:0x4e0c7482698f8138!8m2!3d1.3723972!4d103.8476009!15sCiVUaGUgSGVhcmluZyBDZW50cmUgUHRlIEx0ZCBBTUsgQnJhbmNoIgOIAQFaTgoldGhlIGhlYXJpbmcgY2VudHJlIHB0ZSBsdGQgYW1rIGJyYW5jaCIldGhlIGhlYXJpbmcgY2VudHJlIHB0ZSBsdGQgYW1rIGJyYW5jaJIBEWhlYXJpbmdfYWlkX3N0b3JlmgEkQ2hkRFNVaE5NRzluUzBWSlEwRm5TVU5wZFMxbVNuUm5SUkFC"
                  >
                    Ang Mo Kio Branch
                  </a>
                </p>
                <p>
                  {" "}
                  <i className="fa fa-map-marker" aria-hidden="true"></i>{" "}
                  <a
                    target="_blank"
                    href="https://www.google.com/maps/place/The+Hearing+Centre+Pte+Ltd/@1.3342283,103.8643605,13z/data=!4m9!1m2!2m1!1sThe+Hearing+Centre+Pte+Ltd+!3m5!1s0x31da3d14d610225d:0x1e6aebf45e1b8829!8m2!3d1.3523805!4d103.9421079!15sChpUaGUgSGVhcmluZyBDZW50cmUgUHRlIEx0ZCIDiAEBWjgKGnRoZSBoZWFyaW5nIGNlbnRyZSBwdGUgbHRkIhp0aGUgaGVhcmluZyBjZW50cmUgcHRlIGx0ZJIBEWhlYXJpbmdfYWlkX3N0b3Jl"
                  >
                    Tampines Branch
                  </a>
                </p>
                <p>
                  {" "}
                  <i className="fa fa-map-marker" aria-hidden="true"></i>
                  <a
                    target="_blank"
                    href="https://www.google.com/maps/place/The+Hearing+Centre,+East+Coast/@1.3067693,103.8432641,13z/data=!4m9!1m2!2m1!1sThe+Hearing+Centre+Pte+Ltd+East+Coast+Branch!3m5!1s0x31da23c77a665927:0x183e273c7f7dd000!8m2!3d1.3120835!4d103.9225723!15sCixUaGUgSGVhcmluZyBDZW50cmUgUHRlIEx0ZCBFYXN0IENvYXN0IEJyYW5jaCIDiAEBkgERaGVhcmluZ19haWRfc3RvcmU"
                  >
                    East Coast Branch
                  </a>
                </p>
                <p>
                  {" "}
                  <i className="fa fa-map-marker" aria-hidden="true"></i>
                  <a
                    target="_blank"
                    href="https://www.google.com/maps/place/Hearing+Care+Centre/@11.592507,104.9280032,17z/data=!3m1!4b1!4m5!3m4!1s0x310953d9aff110bb:0x6d3b65e4053162c4!8m2!3d11.592507!4d104.9301919"
                  >
                    Cambodia Branch
                  </a>
                </p>
                <p>
                  {" "}
                  <i className="fa fa-map-marker" aria-hidden="true"></i>
                  <a
                    target="_blank"
                    href="https://maps.app.goo.gl/NSf2UyncEckBVYtX8"
                  >
                    Jurong Branch
                  </a>
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              {" "}
              <div className="Footer_menu">
                <h5>Newsletter Subscription</h5>
                <p>Enter your email below to receive the bonus materials</p>

                <p>Email Address</p>
                <div class="input-group">
                  <input
                    type="email"
                    class="form-control"
                    placeholder="Email"
                    aria-label="Username"
                    value={email}
                    aria-describedby="basic-addon1"
                    onChange={(e)=>setEmail(e.target.value)}
                  />
                </div>

                <button className="btn footer_bnt" onClick={()=>subEmailId()}>
                  Subscribe Now <img src={right} className="img-fluid" />
                </button>
              </div>
            </div>
          </div>

          <div className="row coppy_text align-items-center">
            <div className="col-md-6">
              <p>© {year} The Hearing Centre. All rights reserved.</p>
            </div>

            <div className="col-md-6 d-flex  justify-content-spacebetween space_blog">
              <ul>
                <li>
                  <Link to="/FAQ">FAQ’s </Link>{" "}
                </li>
                <li>
                <a href="#" >Blogs</a>{" "}
                </li>
                <li>
                  <a href="#">Sitemap</a>{" "}
                </li>
                <li>
                  <a href="#">Terms</a>
                </li>
                <li>
                  <a href="#"> Privacy </a>
                </li>
              </ul>

              <ul>
                <li>
                  <a href="https://www.facebook.com/TheHearingCentrePteLtd/" target="_blank">
                    <img src={link1} className="img-fluid" />{" "}
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="https://www.youtube.com/channel/UClsLZIJIvMAA8C2zljxx0Dw" target="_blank">
                    <img src={link2} className="img-fluid" />{" "}
                  </a>
                </li>

                <li>
                  {" "}
                  <a href="https://www.instagram.com/thehearingcentresingapore/" target="_blank">
                    <img src={link3} className="img-fluid" />{" "}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
